// Single source of truth for article content, presentation, and internet metadata.
// Add/update an entry here; the article card, reader, and document/social metadata
// are all derived from the same record.
import articleMarkdownUrl from './myStory.md'
import aiJudgementUrl from "./aiJudgementCourt.md"

const articleMap = {
  'my-story': {
    slug: 'my-story',
    title: 'Story of My Life...',
    excerpt:
      "From barely passing Computer Science exams in high school to becoming the 1st National Winner from my University to win SIH'23 (the largest hackathon of the country) here's my humble story!",
    date: '2026-09-22',
    author: 'Sam',
    readTime: '15 min read',
    tags: ['Systems', 'Product', 'Engineering'],
    imagePath: '/images/adamGod.webp',
    contentUrl: articleMarkdownUrl
  },
  'ai-judgement-court': {
    slug: 'ai-judgement-court',
    title: 'Is There Justice in the Courts of AI?',
    excerpt:
      "Lets replace the lawyers and even judges of a court with AI Agents, orchestrated by JEV (by TypeSafe AI) and see how they perform!",
    date: '2026-09-22',
    author: 'Sam',
    readTime: '10 min read',
    tags: ['JEV', 'Agentic AI', 'Flutter'],
    imagePath: '/images/aiJudgement.webp',
    contentUrl: aiJudgementUrl
  }
}

export const getArticleBySlug = slug => articleMap[slug] || null

const articles = Object.values(articleMap)

export default articles
